const SOURCE_URL_KEY = 'source_url'

export const SourceUrlStorage = {
  get: (): string =>
    typeof window !== 'undefined' ? sessionStorage.getItem(SOURCE_URL_KEY) || '' : '',
  set: (value: string) => {
    if (typeof window !== 'undefined') {
      const url = sessionStorage.getItem(SOURCE_URL_KEY)
      if (!url) sessionStorage.setItem(SOURCE_URL_KEY, value)
    }
  },
}
